import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import { Card, Container } from '@scentregroup/ui'
import {
  CustomThemeContext,
  ThemeOption,
  BasicPageContext,
} from '../../context'
import Article from '../article'
import InfoAccordion from '../info-accordion'
import containerStyle from '../container.scss'
import style from '../feature/index.scss'
import { Centre, RawOpeningHours } from '../../../types/contentful-v1'
import { ParkingModule } from '../../../types/contentful'
import ServiceUtilityBox from '../service-utility-box'
import accordionEntriesFromModules from './accordion-entries-from-modules'

interface ParkingModulesProps {
  centre: Centre
  centreTradingHours: RawOpeningHours
  modules: ParkingModule[]
}

const ParkingModules: FC<ParkingModulesProps> = ({
  centre,
  modules,
  centreTradingHours,
}: ParkingModulesProps): ReactElement => (
  <CustomThemeContext.Consumer>
    {(themeOption: ThemeOption) => (
      <BasicPageContext.Consumer>
        {isBasicPage => (
          <div
            className={classNames(style.Feature, style.placeholder, {
              [style.Grey]: themeOption.luxury,
            })}
          >
            <Container
              type="large"
              className={classNames(containerStyle.container, style.Container)}
            >
              <Card className={style.Card}>
                <Article
                  superheading={isBasicPage ? '' : 'Service'}
                  heading={isBasicPage ? '' : 'Parking'}
                  headingType="large"
                >
                  <InfoAccordion
                    metaRows={accordionEntriesFromModules(modules, centre)}
                    purpose="Parking information"
                    theme="parking"
                  />
                </Article>
              </Card>
              <div className={style.Sidebar}>
                <ServiceUtilityBox
                  centre={centre}
                  centreTradingHours={centreTradingHours}
                />
              </div>
            </Container>
          </div>
        )}
      </BasicPageContext.Consumer>
    )}
  </CustomThemeContext.Consumer>
)

export default ParkingModules
